"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsonapi_1 = require("../HttpClient/jsonapi");
class User {
    constructor(client) {
        this._encryption = false;
        this._firebase = null;
        this._jsonApiClient = client._jsonApiClient;
        this._baseUrl = client.applicationUrl + "/services/me";
        const encryptionOptions = client.options.payloadEncryption;
        if (encryptionOptions && encryptionOptions.enforcement.includes("COMMON")) {
            this._encryption = true;
        }
    }
    _isNode() {
        return (typeof process !== "undefined" &&
            process.versions != null &&
            process.versions.node != null);
    }
    get isLoggedIn() {
        return !!this._jsonApiClient.getAccessToken();
    }
    set firebase(firebase) {
        if (this._isNode()) {
            console.warn("Using Firebase in NodeJS is not supported.");
            return;
        }
        this._firebase = firebase;
    }
    get() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._jsonApiClient.request("GET", this._baseUrl, {
                    encryption: this._encryption,
                });
                return (0, jsonapi_1.deserialize)(res.data, {
                    keyForAttribute: "snake_case",
                });
            }
            catch (err) {
                return { error: (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors) === null || _b === void 0 ? void 0 : _b[0] };
            }
        });
    }
    update(scope, data) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const filter = ["subscribe", "unsubscribe"];
            if (filter.includes(scope)) {
                if (!data || !data.token) {
                    try {
                        const obtainToken = yield this._getFcmToken();
                        if (obtainToken) {
                            data = Object.assign(Object.assign({}, data), { token: obtainToken });
                        }
                    }
                    catch (err) {
                        return { error: Object.assign(Object.assign({}, err), { message: err.message }) };
                    }
                }
            }
            try {
                const res = yield this._jsonApiClient.request("PATCH", this._baseUrl, {
                    data: { scope, data },
                    encryption: this._encryption,
                });
                return (0, jsonapi_1.deserialize)(res.data, {
                    keyForAttribute: "snake_case",
                    extras: { message: res.data.meta.message },
                });
            }
            catch (err) {
                return { error: (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors) === null || _b === void 0 ? void 0 : _b[0] };
            }
        });
    }
    _getFcmToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const firebase = this._firebase;
            if (firebase && typeof firebase.messaging === "function") {
                const messaging = firebase.messaging();
                return messaging.getToken();
            }
            return null;
        });
    }
    logout() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let result;
            try {
                yield this._jsonApiClient.request("DELETE", this._baseUrl, {
                    encryption: this._encryption,
                });
                result = null;
            }
            catch (err) {
                result = { error: (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors) === null || _b === void 0 ? void 0 : _b[0] };
            }
            finally {
                this._jsonApiClient.removeTokenset();
                return result;
            }
        });
    }
}
exports.default = User;
